import request from '@/plugins/request';
import { IBoolResult, IErrorResult } from '@/types/dto';
import { IHost, IServiceCode } from '@/types/models';
import utils from '@/utils';
import { AxiosError, AxiosResponse } from 'axios';

const $url = '/my/serviceCodes';
const $urlBuy = '/my/serviceCodes/actions/buy';
const $urlApply = '/my/serviceCodes/actions/apply';
const $urlPay = '/my/serviceCodes/actions/pay';
const $urlQuery = '/my/serviceCodes/actions/query';

interface IGetResult {
  serviceCodes: IServiceCode[];
}

interface IBuyResult {
  hosts: IHost[];
  price: number;
}

interface IApplyRequest {
  hostId: number;
}

interface IPayRequest {
  channel: string;
  amount: number;
}

interface IPayResult {
  orderNo: string;
  qrCodeUrl: string;
}

interface IQueryRequest {
  orderNo: string;
}

interface IQueryResult {
  isPurchased: boolean;
}

export default {
  get(success: (res: IGetResult) => void) {
    utils.loading(true);
    request
      .get($url)
      .then((response: AxiosResponse<IGetResult>) => {
        success(response.data);
      })
      .catch(error => {
        utils.error(error);
      })
      .then(() => {
        utils.loading(false);
      });
  },

  buy(success: (res: IBuyResult) => void) {
    utils.loading(true);
    request
      .post($urlBuy)
      .then((response: AxiosResponse<IBuyResult>) => {
        success(response.data);
      })
      .catch(error => {
        utils.error(error);
      })
      .then(() => {
        utils.loading(false);
      });
  },

  apply(req: IApplyRequest, success: (res: IBoolResult) => void) {
    utils.loading(true);
    request
      .post($urlApply, req)
      .then((response: AxiosResponse<IBoolResult>) => {
        success(response.data);
      })
      .catch(error => {
        utils.error(error);
      })
      .then(() => {
        utils.loading(false);
      });
  },

  pay(req: IPayRequest, success: (res: IPayResult) => void, failure: (error: AxiosError<IErrorResult> | string) => void) {
    utils.loading(true);
    request
      .post($urlPay, req)
      .then((response: AxiosResponse<IPayResult>) => {
        success(response.data);
        utils.loading(false);
      })
      .catch(error => {
        failure(error);
      });
  },

  query(req: IQueryRequest, success: (res: IQueryResult) => void) {
    request
      .post($urlQuery, req)
      .then((response: AxiosResponse<IQueryResult>) => {
        success(response.data);
      })
      .catch(error => {
        utils.error(error);
      });
  },
};
